/**
 * This component is used as part of any input in the form design system to render the label
 * For better performance, it should be rendered conditionally based on the label prop if it exists
 */
import { cn } from "@app/lib/utils";
import { type ReactNode } from "react";

export type InputLabelProps = {
  children: ReactNode;
  htmlFor?: string;
  required?: boolean;
  className?: string;
  onClick?: () => void;
};

export function InputLabel({
  htmlFor,
  className,
  required,
  children,
  ...props
}: InputLabelProps) {
  return (
    <>
      {children && (
        <div className={cn("pb-3", className)}>
          <label
            htmlFor={htmlFor}
            className="text-lg font-medium text-mine-shaft md:text-xl"
            {...props}
          >
            {children}
          </label>
          {required && <span className="ms-1 text-red-700">*</span>}
        </div>
      )}
    </>
  );
}
